import {  AppRemixIcon } from '@/layout/AppComponents';
import colors from '../constants/colors';

export const fileIcon = (fileName, split = true, color = null, className = '') => {
  const extension = split ? (fileName.split('.'))[(fileName.split('.')).length - 1] : fileName;
  switch (extension) {
    case 'pdf': return <AppRemixIcon icon="file-pdf" className={className} color={color || colors.danger} />;
    case 'xls':
    case 'xlsx': return <AppRemixIcon icon="file-excel" className={className} color={color || colors.success} />;
    case 'doc':
    case 'docx': return <AppRemixIcon icon="file-word" className={className} color={color || colors.primary} />;
    case 'png':
    case 'gif':
    case 'jpeg':
    case 'jpg': return <AppRemixIcon icon="file-image" className={className} color={color || colors.grey600} />;
    case 'rar':
    case '7zip':
    case 'tar':
    case 'zip': return <AppRemixIcon icon="file-archive" className={className} color={color || colors.grey600} />;
    default: return <AppRemixIcon icon="file-4" className={className} color={color || colors.grey600} />;
  }
};
